import { RenderElementProps } from 'slate-react';
import { BookmarkElement as BookmarkElementNode } from 'slate/types/slate';

export const BookmarkElement = ({ attributes, children, element }: RenderElementProps) => {
  const bookmark = element as BookmarkElementNode;
  return (
    <span {...attributes} id={bookmark.id} className="xrp-bookmark">
      {children}
    </span>
  );
};
